import { forceLink } from 'd3-force';

import {
  D3LayoutLink,
  D3LayoutNode,
} from 'src/containers/ProjectDiagram/templates/extensions/layouts/ForceDirectedLayout/types';
import { ForceLayoutSettings } from 'src/containers/ProjectDiagram/templates/extensions/layouts/types';

const getLinkLengthForNeighbours = (
  perimeter: number,
  currentLength: number
) => {
  const radius = perimeter / (2 * Math.PI);
  return Math.max(radius, currentLength);
};

const calculateLinkLength =
  (layoutSettings: ForceLayoutSettings) => (link: D3LayoutLink) => {
    const source = link.source as D3LayoutNode;
    const target = link.target as D3LayoutNode;
    let linkLength = layoutSettings.edgeMinLength;

    linkLength = getLinkLengthForNeighbours(link.fromPerimeter, linkLength);
    linkLength = getLinkLengthForNeighbours(link.toPerimeter, linkLength);

    const edgePropertyOffset = link.isEdgeProperty
      ? layoutSettings.edgePropertyEdgeOffset
      : 0;
    const additionalOffset = link.isArtificial
      ? layoutSettings.separateGraphOffset
      : edgePropertyOffset;

    return (
      source.radius +
      target.radius +
      Math.max(linkLength, layoutSettings.edgeOffset) +
      additionalOffset
    );
  };

export const forceLinkSimulation = (
  layoutSettings: ForceLayoutSettings,
  links: D3LayoutLink[]
) =>
  forceLink<D3LayoutNode, D3LayoutLink>(links)
    .id((node: D3LayoutNode) => node.key)
    .distance(calculateLinkLength(layoutSettings));
